import { type JSX } from 'react';

import { Splash } from '@opositandopn/ui';

import { BootError } from './BootError';

type BootStatusProps = {
  /** Whether this step has given up, as opposed to still working. */
  failed?: boolean;
  /** What to tell the user when it has. */
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  retrying?: boolean;
};

/**
 * What a boot step shows while it is not yet done: the splash if it is still working,
 * an error with a way out if it has given up.
 *
 * Every provider in the chain gates the whole app, so each one that hand-rolls this
 * is a chance to leave a user on a splash with no way off it — which is what four
 * separate copies had already started to do. Only the message differs between steps,
 * which is why it is the only part still passed in.
 */
function BootStatus({
  failed = false,
  message,
  onRetry,
  retryLabel,
  retrying,
}: BootStatusProps): JSX.Element {
  if (!failed) {
    return <Splash />;
  }

  return (
    <BootError
      message={message}
      onRetry={onRetry}
      retryLabel={retryLabel}
      retrying={retrying}
    />
  );
}

export { BootStatus };
